import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomModal from "../../../shared/CustomModal";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { toast } from "react-toastify";
import { patchCodManagementFn, postCodManagementFn } from "../../../Services/CodManagement";
import { useMutation, useQueryClient } from "react-query";

// ✅ Validation Schema
const CodSchema = Yup.object({
    min_amount: Yup.number()
        .typeError("Must be a number")
        .required("Min Price is required")
        .min(0, "Min Price must be at least 0"),
    max_amount: Yup.number()
        .typeError("Must be a number")
        .required("Max Price is required")
        .moreThan(Yup.ref("min_amount"), "Max Price must be greater than Min Price"),
});

const AddCodManagement = ({ data, setInitailValues }) => {

    const store_id = localStorage.getItem("store_id");

    const client = useQueryClient()

    const [open, setOpen] = useState()


    const { mutate: AddCod, isLoading } = useMutation(postCodManagementFn, {

        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("cod-price")
                handleClose()

            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })
    const { mutate: UpdateCod, isLoading1 } = useMutation(patchCodManagementFn, {

        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("cod-price")
                handleClose()

            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })
    const formik = useFormik({
        initialValues: {
            min_amount: data?.min_amount || "",
            max_amount: data?.max_amount || "",
        },

        enableReinitialize: true,
        validationSchema: CodSchema,
        onSubmit: (values, { resetForm }) => {
            if (data) {

                UpdateCod({ cod_amount_id: data?.id, ...values, store: store_id })

            }

            else {

                AddCod({ store: store_id, ...values })

            }


        },
    });

    function handleClose() {
        setOpen(false)

        setInitailValues(null)
        formik.handleReset()

    }

    return (

        <>

            <Button onClick={() => setOpen(true)} variant="outlined" size="small" startIcon={<Add />}>Add</Button>

            <CustomModal open={open || data} onClose={handleClose} title={`${data ? "Update" : "Add"} Cod Price`} >

                <div className="w-full  bg-white shadow-lg rounded-2xl p-6">
                    <h2 className="text-xl font-bold mb-4 text-center">COD Management</h2>

                    <form onSubmit={formik.handleSubmit} className="space-y-4">
                        {/* Min Price */}
                        <div>
                            <label className="block mb-1 font-medium">Min Price</label>
                            <input
                                type="number"
                                name="min_amount"
                                placeholder="Enter minimum price"
                                className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                value={formik.values.min_amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.min_amount && formik.errors.min_amount && (
                                <div className="text-red-500 text-sm mt-1">
                                    {formik.errors.min_amount}
                                </div>
                            )}
                        </div>

                        {/* Max Price */}
                        <div>
                            <label className="block mb-1 font-medium">Max Price</label>
                            <input
                                type="number"
                                name="max_amount"
                                placeholder="Enter maximum price"
                                className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                value={formik.values.max_amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.max_amount && formik.errors.max_amount && (
                                <div className="text-red-500 text-sm mt-1">
                                    {formik.errors.max_amount}
                                </div>
                            )}
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-between gap-3">

                            <button
                                type="button"
                                onClick={() => formik.resetForm()}
                                className="flex-1 bg-gray-300 text-black py-2 rounded-md hover:bg-gray-400 transition"
                            >
                                Reset
                            </button>
                            <button
                                type="submit"
                                disabled={formik.isSubmitting}
                                className="flex-1 bg-[#F66742] text-white py-2 rounded-md hover:bg-[#F66742] transition"
                            >
                                {(isLoading || isLoading1) ? "Saving..." : "Apply COD"}
                            </button>


                        </div>
                    </form>
                </div>
            </CustomModal>
        </>
    );
};

export default AddCodManagement;
